// f:/checkin/frontend/src/components/ui/FAQAccordionItem.jsx
import React from 'react';

const FAQAccordionItem = ({ id, question, answer, isFirstItem }) => {
    const collapseId = `collapse${id}`;
    const headingId = `heading${id}`;

    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={headingId}>
                <button
                    className={`accordion-button ${!isFirstItem ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${collapseId}`}
                    aria-expanded={isFirstItem ? "true" : "false"}
                    aria-controls={collapseId}
                >
                    {question}
                </button>
            </h2>
            <div
                id={collapseId}
                className={`accordion-collapse collapse ${isFirstItem ? 'show' : ''}`}
                aria-labelledby={headingId}
                data-bs-parent="#faqAccordion" // This assumes the parent accordion has id="faqAccordion"
            >
                <div className="accordion-body">{answer}</div>
            </div>
        </div>
    );
};

export default FAQAccordionItem;
